import { AGENTS_ERROR, AGENTS_REQUEST, AGENTS_SUCCESS } from './types';

const initialState = {
  data   : {},
  error  : null,
  loading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case AGENTS_ERROR:
      return {
        ...state,
        error  : action.error,
        loading: false,
      };
    case AGENTS_REQUEST:
      return {
        ...state,
        error  : null,
        loading: true,
      };
    case AGENTS_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.data,
        },
        loading: false,
      };
    default:
      return state;
  }
}
